import type { User } from '@centric-os/types';
import { computed, ref, type Ref } from 'vue';
import { useI18n, type Path, type NamedValue, type TranslateOptions } from 'vue-i18n';

export const getUserFirstName = (user: User) => user.firstName || '';

export const getUserLastName = (user: User) => user.lastName || '';

type Translator = {
  (key: Path | number): string;
  (key: Path | number, named: NamedValue, options?: TranslateOptions): string;
};

export const getUserFullName = (user: User) => {
  let name = '';

  if (user?.fullName) {
    return user.fullName;
  }

  if (user?.firstName) {
    name = user.firstName;
  }

  if (user?.lastName) {
    name += ' ';
    name += user.lastName;
  }

  return name;
};

export const getUserFullNameOrPending = (user: User, t: Translator) => {
  return user?.lastLoggedInAt ? getUserFullName(user) : t('user.pending');
};

export const useGetUserName = (userValue: Ref<User> | User) => {
  const { t } = useI18n();
  const user = ref(userValue);

  const firstName = computed(() => getUserFirstName(user.value as User));
  const lastName = computed(() => getUserLastName(user.value as User));
  const fullName = computed(() => getUserFullName(user.value as User));
  const fullNameOrPending = computed(() => getUserFullNameOrPending(user.value as User, t));

  return {
    firstName,
    fullName,
    fullNameOrPending,
    lastName,
  };
};
